<script>
    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
    } from "../services/constants"

    export default {
        name: 'base-loading-component',
        data: function () {
            return {
                LOADING_PRISTINE: LOADING_PRISTINE,
                LOADING_STARTED: LOADING_STARTED,
                LOADING_COMPLETED_SUCCESS: LOADING_COMPLETED_SUCCESS,
                LOADING_COMPLETED_FAILURE: LOADING_COMPLETED_FAILURE,
            }
        }
    }
</script>